<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="alert alert-success col-lg-12">
              আপনার অর্ডারটি সফলভাবে সম্পন্ন হয়েছে । ধন্যবাদ
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `login`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
    };
  },
  mounted(){
      localStorage.setItem("cart", "");
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
  }
};
</script>
